/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PetBreedSizeModel = {
    Unknown: 'UNKNOWN',
    Xs: 'XS',
    Sm: 'SM',
    M: 'M',
    L: 'L',
    Xl: 'XL',
    G: 'G'
} as const;
export type PetBreedSizeModel = typeof PetBreedSizeModel[keyof typeof PetBreedSizeModel];


export function PetBreedSizeModelFromJSON(json: any): PetBreedSizeModel {
    return PetBreedSizeModelFromJSONTyped(json, false);
}

export function PetBreedSizeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetBreedSizeModel {
    return json as PetBreedSizeModel;
}

export function PetBreedSizeModelToJSON(value?: PetBreedSizeModel | null): any {
    return value as any;
}

